'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
*/

module.exports = function (mixins) {

    var prototype = {};

    for (var i = 0, n = mixins.length; i < n; i++) {

        var mixin = mixins[i];
        var keys = Object.keys(mixin);

        for (var j = 0, n2 = keys.length; j < n2; j++) {
            var key = keys[j];
            var value = mixin[key];
            var tov = typeof value === 'undefined' ? 'undefined' : _typeof(value);

            if (tov === 'function') {
                if (prototype[key]) {
                    value = combineFunction(prototype[key], value);
                }
            }

            prototype[key] = value;
        }
    }

    return prototype;
};

/**
*/

function combineFunction(oldFn, newFn) {
    return function () {
        oldFn.apply(this, arguments);
        return newFn.apply(this, arguments);
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/base/_mixin.js
 ** module id = 494
 ** module chunks = 0 1
 **/